import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  bg?: 'warm' | 'section' | 'highlight';
  id?: string;
}
export function Section({
  children,
  className = '',
  bg = 'warm',
  id
}: SectionProps) {
  const bgColors = {
    warm: 'bg-warm-bg',
    section: 'bg-warm-section',
    highlight: 'bg-warm-highlight'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 ${bgColors[bg]} ${className}`} data-id="element-173">
      <div className="max-w-2xl mx-auto" data-id="element-174">{children}</div>
    </section>;
}